// extracted by mini-css-extract-plugin
export var LinkStyle = "fil-ariane-module--LinkStyle--c6fff";
export var TypoAriane = "fil-ariane-module--TypoAriane--4c1ca";
export var lastElementStyle = "fil-ariane-module--lastElementStyle--0c3bf";
export var rootAriane = "fil-ariane-module--rootAriane--7947f";
export var separator = "fil-ariane-module--separator--cb420";